import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import FullCalendar, { EventClickArg } from '@fullcalendar/react';
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from '@fullcalendar/list';
import allLocales from '@fullcalendar/core/locales-all';
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";

import { CalendarEvent } from './CalendarEvent';
import { ListEvent } from './ListEvent';

import { selectIsAdministrator } from 'main/store/common/selectors';
import { selectScheduleEvents } from 'main/store/schedule/selectors';
import { Event, EventType } from 'main/store/schedule/state';
import { actions } from 'main/store/schedule/reducer';
import { format } from 'date-fns';

export const Schedule = () => {
    const dispatch = useDispatch();
    const isAdministrator = useSelector(selectIsAdministrator);
    const events = useSelector(selectScheduleEvents);

    const handleEventClick = useCallback((arg: EventClickArg) => {
        if (arg.view.type === 'dayGridMonth') {
            const event: Event = {
                id: arg.event.id,
                type: arg.event.title as EventType,
                date: format(arg.event.start!, 'yyyy-MM-dd'),
                startTime: format(arg.event.start!, 'HH:mm'),
                endTime: format(arg.event.end!, 'HH:mm'),
                place: arg.event.extendedProps.place,
                description: arg.event.extendedProps.description
            }
            if (isAdministrator) {
                dispatch(actions.openEventUploadDialog(event));
            } else {
                dispatch(actions.openEventReferenceDialog(event));
            }
        }
    }, [isAdministrator, dispatch]);

    const handleDateClick = useCallback((arg: DateClickArg) => {
        if (isAdministrator) {
            const event: Event = {
                type: 'PM練習',
                date: format(arg.date, 'yyyy-MM-dd'),
                startTime: '13:00',
                endTime: '17:00',
                place: '相模台小',
                description: ''
            };
            dispatch(actions.openEventUploadDialog(event));
        }
    }, [isAdministrator, dispatch]);

    const renderEvent = useCallback((arg) => {
        return arg.view.type === 'dayGridMonth' ?
            <CalendarEvent
                title={arg.event.title}
                place={arg.event.extendedProps.place}
            /> :
            <ListEvent
                title={arg.event.title}
                place={arg.event.extendedProps.place}
                description={arg.event.extendedProps.description}
            />
    }, []);

    return (
        <Box px={1} py={1} height="100%">
            <FullCalendar
                plugins={[dayGridPlugin, listPlugin, interactionPlugin]}
                initialView="listMonth"
                locales={allLocales}
                locale="ja"
                height="auto"
                events={events}
                eventClick={handleEventClick}
                dateClick={handleDateClick}
                dayCellContent={(e) => {
                    e.dayNumberText = e.dayNumberText.replace('日', '')
                }}
                eventContent={renderEvent}
                headerToolbar={{ start: 'prev,next', center: 'title', end: 'listMonth,dayGridMonth' }}
                buttonText={{ list: 'リスト', month: 'カレンダー' }}
                listDayFormat={{ month: 'long', day: 'numeric', weekday: 'short' }}
                listDaySideFormat={false}
                validRange={{ start: Date.now() }}
            />
        </Box>
    )
}
